import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LockIcon } from '../icons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
const FAILURE_MESSAGE = {
    invalid: 'Invalid password.',
    blocked: 'Another tab has this vault open. Close it and try again.',
    stale: 'This tab is out of date. Reload the page to continue.',
    unavailable: 'This browser blocked local storage, so the vault cannot be opened.',
    error: 'The vault could not be opened.',
};
const LockPasswordForm = ({ passwordState, onSubmit }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [shake, setShake] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const shakeTimer = useRef(undefined);
    const triggerShake = useCallback(() => {
        setShake(true);
        clearTimeout(shakeTimer.current);
        shakeTimer.current = setTimeout(() => setShake(false), 500);
    }, []);
    useEffect(() => {
        const message = passwordState === undefined ? undefined : FAILURE_MESSAGE[passwordState];
        if (message === undefined)
            return;
        setSubmitting(false);
        setError(message);
        triggerShake();
    }, [passwordState, triggerShake]);
    useEffect(() => () => clearTimeout(shakeTimer.current), []);
    const unlock = useCallback(() => {
        if (submitting)
            return;
        if (!password) {
            setError('Enter a password.');
            triggerShake();
            return;
        }
        setSubmitting(true);
        setError('');
        onSubmit(password);
    }, [submitting, password, triggerShake, onSubmit]);
    return (_jsxs("form", { className: 'lock__unlock-form', children: [_jsx("div", { className: 'lock__label', children: "Password" }), _jsxs("div", { className: `lock__field${shake ? ' shake' : ''}`, children: [_jsx(LockIcon, { w: 16, h: 16, sw: 1.8 }), _jsx("input", { type: 'password', autoComplete: 'off', value: password, onChange: (e) => {
                            setPassword(e.target.value);
                            setError('');
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                unlock();
                            }
                        }, placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022' })] }), _jsx("div", { className: 'lock__error', children: error }), _jsx("button", { className: 'lock__submit', type: 'button', onClick: unlock, children: passwordState === 'migrating' ? 'Upgrading vault…' : submitting ? 'Unlocking…' : 'Unlock' })] }));
};
export default React.memo(LockPasswordForm);
